import React, { PropTypes } from 'react';
import ContentBody from '../../containers/ContentBody';

const Annoucnement = ({ body, title, edition }) => (
  <div className="fold fold--about fold--deco fold--main fold--main--full">
    <div className="fold--main__inner">
      <section className="fold__col fold__col--main">
        <header className="fold__col__header">
          <h1 className="fold__col__title">
            { title }
          </h1>
        </header>
        <div className="fold__col__body">
          <ContentBody background={edition.background} body={body} />
        </div>
      </section>
    </div>
  </div>
);

export default Annoucnement;

Annoucnement.propTypes = {
  body: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    id: PropTypes.string,
    year: PropTypes.string,
  }).isRequired,
};



// WEBPACK FOOTER //
// ./js/components/happenings/Announcement.js